var map = {
	"./skin1/edit_bar_selected@3x.png": "10af",
	"./skin2/edit_bar_selected@3x.png": "089b",
	"./skin3/edit_bar_selected@3x.png": "d52b",
	"./skin4/edit_bar_selected@3x.png": "8379",
	"./skin5/edit_bar_selected@3x.png": "365b",
	"./skin6/edit_bar_selected@3x.png": "862c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bc63";